module.exports = __webpack_public_path__ + "media/images/polish-d452ee0e6b5d3816afbde989ee8ad62d.png";